import { render, staticRenderFns } from "./FirewallRules.vue?vue&type=template&id=35176212&"
import script from "./FirewallRules.vue?vue&type=script&lang=js&"
export * from "./FirewallRules.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports